import "./Cards.css"

const Cards = () => {
    return (
        <div className="main_cards">
            <div className="card">
                <div className="card_icon">
                    <i className="fa fa-user-o text-lightblue"></i>
                </div>
                <div className="card_right">
                    <span>425</span>
                    <p>Total Users</p>
                </div>
            </div>
            <div className="card">
                <div className="card_icon">
                    <i className="fa fa-calendar text-red"></i>
                </div>
                <div className="card_right">
                    <span>425</span>
                    <p>Total Times</p>
                </div>
            </div>
            <div className="card">
                <div className="card_icon">
                    <i className="fa fa-video-camera text-yellow"></i>
                </div>
                <div className="card_right">
                    <span>425</span>
                    <p>Total Videos</p>
                </div>
            </div>
            <div className="card">
                <div className="card_icon">
                    <i className="fa fa-thumbs-up text-green"></i>
                </div>
                <div className="card_right">
                    <span>425</span>
                    <p>Total Likes</p>
                </div>
            </div>
        </div>
    )
}

export default Cards;